import { render, staticRenderFns } from "./ShipDShipDashboardWidget.vue?vue&type=template&id=58a9187f&scoped=true"
import script from "./ShipDShipDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipDShipDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipDShipDashboardWidget.vue?vue&type=style&index=0&id=58a9187f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a9187f",
  null
  
)

export default component.exports